// Background tile images
export const DATA_IMAGES = {
  STRIPED_LIGHT:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAADtJREFUKFNjZICC/////4exQTQjIyMjmAYRuCTBCvBJYiiAGYtsLdwEbJJwE3BJwh2J7HoMN+GVBHoVAJHmK/mFm0SxAAAAAElFTkSuQmCC',
  STRIPED_DARK:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAADtJREFUKFNjZICCu3fv/oexQbSysjIjiAYTuCTBCvBJYiiAGYtsLdwEbJJwE3BJwh2J7Hp0N4F9gc+rANzzKmFY4J1ZAAAAAElFTkSuQmCC',
};
